// extracted by mini-css-extract-plugin
export var formContainer = "_co-0";
export var message = "_co-1";